import { render, staticRenderFns } from "./OrdreEixidaDetail.vue?vue&type=template&id=c94da6d0&scoped=true"
import script from "./OrdreEixidaDetail.vue?vue&type=script&lang=js"
export * from "./OrdreEixidaDetail.vue?vue&type=script&lang=js"
import style0 from "./OrdreEixidaDetail.vue?vue&type=style&index=0&id=c94da6d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c94da6d0",
  null
  
)

export default component.exports